import { useEffect, useState } from "react";
import { noInternetMsg,serverMsg} from "../../../../config/messageconstant";

// Shared fetch-once + print hook. Pass feature-specific fetchData().
export const useProductWiseSkuPdfData = ({
  showLoador,
  showNotification,
  fetchData,
}) => {
  const [billList, setBillList] = useState({});

  useEffect(() => {
    if (!navigator.onLine) {
      showNotification({ msg: noInternetMsg, severity: "error" });
      return;
    }

    showLoador({ loador: true });
    fetchData().then(({ data, success }) => {
      showLoador({ loador: false });
      if (!success) {
        showNotification({
          msg: serverMsg,
          severity: "error",
        });
        return;
      }
      setBillList(data.data);
      window.print();
    });
  }, []);

  return { billList };
};
